/*
 * @Author: LGY 18588437913@163.com
 * @Date: 2023-02-20 11:41:29
 * @LastEditors: LGY 18588437913@163.com
 * @LastEditTime: 2023-02-20 13:43:37
 * @FilePath: /dz-signup-stupc/src/utils/encrypt.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import CryptoJS from "crypto-js";

const encrypt = (uname, pword) => {
  const Keys = CryptoJS.MD5(uname);

  // 用户名MD5的小写，后16位当秘钥
  const key = CryptoJS.enc.Utf8.parse(Keys.toString().substring(16));
  const iv = key; //使用key 当偏移

  // Encrypt
  const ciphertext = CryptoJS.AES.encrypt(pword, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return ciphertext.toString();
  // 展示密文
  // console.log(ciphertext.toString());
  // 传后端的密码： ciphertext.toString()

  // const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), key, {
  //   iv: iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.ZeroPadding
  // });
  // const plaintext = bytes.toString(CryptoJS.enc.Utf8);
  // 解密展示
  // console.log(plaintext);
};
export { encrypt };
